<script>
import PageLayout from "@/components/PageLayout";
import { CorrectionSideBar } from "@/views/Correction/CorrectionSidebar";

export default {
  name: "SummaryIndex",
  components: { PageLayout },
  data: () => ({
    sideBarLinks: CorrectionSideBar,
  }),
};
</script>

<template>
  <div>
    <PageLayout title="Меню" :sidebar-links="sideBarLinks" />
  </div>
</template>

<style scoped lang="scss"></style>
